export enum DeliveryState {
  Open, Assigned, Closed, Cancelled
}